import * as React from 'react';

const Mail = (props) => (
  <svg
    width={25}
    height={25}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.506 9.952c-.013.539-.013 1.15-.013 1.849v2c0 2.828 0 4.242.879 5.121.879.879 2.293.879 5.121.879h6c2.829 0 4.243 0 5.121-.879.88-.879.88-2.293.88-5.121v-2c0-.698 0-1.31-.014-1.849l-8.016 4.453a2 2 0 0 1-1.942 0L3.506 9.952Zm.23-2.122c.083.021.165.053.243.097l8.514 4.73 8.514-4.73c.079-.044.16-.076.243-.096-.13-.474-.33-.845-.636-1.152-.878-.878-2.292-.878-5.12-.878h-6c-2.83 0-4.243 0-5.122.878-.306.307-.506.678-.636 1.151Z"
      fill="#549A9A"
    />
  </svg>
);

export default Mail;
